import getLocalString from "constants/Localization";
import { GetProductGroupsDocument, useDeleteProductGroupMutation } from "generated/graphql";
import { usePaginatedVariables } from "hooks/strings/usePaginatedVariables";
import useBitumioMutation from "hooks/useBitumioMutation";

export default function useDeleteProductGroup() {
  const { offset, filtering } = usePaginatedVariables();
  const [mutation, { data, loading, error }] = useDeleteProductGroupMutation({
    refetchQueries: [
      {
        query: GetProductGroupsDocument,
        variables: {
          page: offset.page,
          first: offset.first,
          search: filtering.debouncedSearchTerm,
        },
      },
    ],
  });

  const [deleteProductGroup, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "deleteProductGroup",
    },
    {
      successMessage: getLocalString("product-groups.delete-success"),
      failureMessage: getLocalString("product-groups.delete-failure"),
    }
  );

  return [deleteProductGroup, context] as const;
}
